import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg } from "@/lib/api";

const LABEL = { admin: "Admin (akses penuh)", verifikator: "Verifikator (edit & verifikasi)", operator: "Operator (lihat saja)", pending: "Belum ada akses" };

export default function UsersTab({ me }) {
  const api = useApi();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = useCallback(() => api("get", "/users").then((r) => setData(r.data)), [api]);
  useEffect(() => { load(); }, [load]);

  const change = async (uid, role) => {
    try { await api("patch", `/users/${uid}/role`, { role }); toast.success("Peran diperbarui"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="mt-4" data-testid="users-tab">
      <div className="border border-white/10 bg-[#0d0d0d] p-4 text-sm text-neutral-300">
        Cara menambah staf: minta staf membuka <b>/sign-up</b> dan mendaftar dengan email + kata sandi. Setelah itu akunnya muncul di sini, lalu pilih perannya.
      </div>
      <div className="border border-white/10 mt-4 divide-y divide-white/10">
        {data.users.map((u) => (
          <div key={u.user_id} data-testid={`user-row-${u.email}`} className="flex flex-wrap items-center justify-between gap-3 p-4">
            <div>
              <p className="font-semibold">{u.name || u.email}{u.user_id === me.user_id && <span className="text-xs text-[#FF5A00] ml-2">(Anda)</span>}</p>
              <p className="text-xs text-neutral-400">{u.email}</p>
            </div>
            <Select value={u.role} onValueChange={(v) => change(u.user_id, v)}>
              <SelectTrigger className="w-56 bg-[#121212]" data-testid={`role-select-${u.email}`}><SelectValue /></SelectTrigger>
              <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r} data-testid={`role-option-${r}`}>{LABEL[r] || r}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
}
